export default __webpack_public_path__ + "e90e81fbe7ae55daedc47ab327cc524d.png";